<template>
  <div class="box">
    <div class="card step-card">
      <h1 v-if="options.title" class="step-title">{{ options.title }}</h1>
      <p v-if="options.description" class="mb-3 step-description">
        <span>
          {{ options.description }}
        </span>
      </p>
      <div class="row">
        <div class="col-12">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  components: {},
  props: {
    resource: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    options: { type: Object, default: () => ({ title: '', description: '' }) },
  },
  setup(props) {
    const resourceType = ref(props.resource.meta.resourceType);
    return {
      resourceType,
    };
  },
};
</script>
